"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShoppingContextReloader = getShoppingContextReloader;
exports.reloadShoppingContext = reloadShoppingContext;
var _requestClearShoppingCache = require("@ori-events/request-clear-shopping-cache");
var _constants = require("../constants");
var _log = require("./log");
/**
 * @param appName Application name / logger key.
 * @returns Function wich reloads shopping context with flushed cache.
 */
function getShoppingContextReloader(appName) {
  return () => reloadShoppingContext(appName);
}
function reloadShoppingContext(appName) {
  const logInfo = (0, _log.getInfoLogger)(appName ?? _constants.APP_NAME);
  window.dispatchEvent(new CustomEvent(_requestClearShoppingCache.Name, {
    detail: {
      isImmediateReloadRequired: true
    }
  }));
  logInfo('Shopping context reload was called.');
}
